import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { FieldTextInput } from '../../components';
import { required } from '../../util/validators';

export const USER_GENERATED_BRAND_NAME = 'userGeneratedBrandName';

const ItemBrandForm: FC = () => (
  <Box pb={1}>
    <FieldTextInput
      id={USER_GENERATED_BRAND_NAME}
      name={USER_GENERATED_BRAND_NAME}
      label="Brand"
      placeholder="Enter a brand for your item"
      validate={required('Please specify a brand.')}
    />
  </Box>
);

export default ItemBrandForm;
